
import Anavitoria1 from '../assets/images/Anavitoria/image00001.jpeg';
import Anavitoria2 from '../assets/images/Anavitoria/image00002.jpeg';
import Anavitoria3 from '../assets/images/Anavitoria/image00003.jpeg';
import Anavitoria4 from '../assets/images/Anavitoria/image00004.jpeg';
import Anavitoria5 from '../assets/images/Anavitoria/image00005.jpeg';
import Anavitoria6 from '../assets/images/Anavitoria/image00006.jpeg';
import Anavitoria7 from '../assets/images/Anavitoria/image00007.jpeg';
import Anavitoria8 from '../assets/images/Anavitoria/image00008.jpeg';
import Anavitoria9 from '../assets/images/Anavitoria/image00009.jpeg';
import Anavitoria10 from '../assets/images/Anavitoria/image00010.jpeg';
import Anavitoria11 from '../assets/images/Anavitoria/image00011.jpeg';
import Anavitoria12 from '../assets/images/Anavitoria/image00012.jpeg';
import Anavitoria13 from '../assets/images/Anavitoria/image00013.jpeg';
import Anavitoria14 from '../assets/images/Anavitoria/image00014.jpeg';
import Anavitoria15 from '../assets/images/Anavitoria/image00015.jpeg';
import Anavitoria16 from '../assets/images/Anavitoria/image00016.jpeg';
import Anavitoria17 from '../assets/images/Anavitoria/image00017.jpeg';
import Anavitoria18 from '../assets/images/Anavitoria/image00018.jpeg';
import Anavitoria19 from '../assets/images/Anavitoria/image00019.jpeg';
import Anavitoria20 from '../assets/images/Anavitoria/image00020.jpeg';
import Anavitoria21 from '../assets/images/Anavitoria/image00021.jpeg';
import Anavitoria22 from '../assets/images/Anavitoria/image00022.jpeg';
import Anavitoria23 from '../assets/images/Anavitoria/image00023.jpeg';
import Anavitoria24 from '../assets/images/Anavitoria/image00024.jpeg';
import Anavitoria25 from '../assets/images/Anavitoria/image00025.jpeg';
import Anavitoria26 from '../assets/images/Anavitoria/image00026.jpeg';
import Anavitoria27 from '../assets/images/Anavitoria/image00027.jpeg';
import Anavitoria28 from '../assets/images/Anavitoria/image00028.jpeg';
import Anavitoria29 from '../assets/images/Anavitoria/image00029.jpeg';
import Anavitoria30 from '../assets/images/Anavitoria/image00030.jpeg';
import Anavitoria31 from '../assets/images/Anavitoria/image00031.jpeg';
import Anavitoria32 from '../assets/images/Anavitoria/image00032.jpeg';
import Anavitoria33 from '../assets/images/Anavitoria/image00033.jpeg';

import ChicoChico1 from '../assets/images/ChicoChico/image00001.png';
import ChicoChico2 from '../assets/images/ChicoChico/image00002.JPG';
import ChicoChico3 from '../assets/images/ChicoChico/image00003.JPG';
import ChicoChico4 from '../assets/images/ChicoChico/image00004.JPG';
import ChicoChico5 from '../assets/images/ChicoChico/image00005.JPG';
import ChicoChico6 from '../assets/images/ChicoChico/image00006.JPG';
import ChicoChico7 from '../assets/images/ChicoChico/image00007.JPG';
import ChicoChico8 from '../assets/images/ChicoChico/image00008.JPG';
import ChicoChico9 from '../assets/images/ChicoChico/image00009.JPG';
import ChicoChico10 from '../assets/images/ChicoChico/image00010.JPG';
import ChicoChico11 from '../assets/images/ChicoChico/image00011.JPG';
import ChicoChico12 from '../assets/images/ChicoChico/image00012.JPG';
import ChicoChico13 from '../assets/images/ChicoChico/image00013.JPG';
import ChicoChico14 from '../assets/images/ChicoChico/image00014.JPG';
import ChicoChico15 from '../assets/images/ChicoChico/image00015.JPG';
import ChicoChico16 from '../assets/images/ChicoChico/image00016.JPG';
import ChicoChico17 from '../assets/images/ChicoChico/image00017.JPG';
import ChicoChico18 from '../assets/images/ChicoChico/image00018.JPG';

import DayLimns1 from '../assets/images/DayLimns/image00001.jpg';
import DayLimns2 from '../assets/images/DayLimns/image00002.jpg';
import DayLimns3 from '../assets/images/DayLimns/image00003.jpg';
import DayLimns4 from '../assets/images/DayLimns/image00004.jpg';
import DayLimns5 from '../assets/images/DayLimns/image00005.jpg';
import DayLimns6 from '../assets/images/DayLimns/image00006.jpg';
import DayLimns7 from '../assets/images/DayLimns/image00007.jpg';

import EstebanInfinu1 from '../assets/images/EstebanInfinu/1.jpg';
import EstebanInfinu2 from '../assets/images/EstebanInfinu/2.jpg';
import EstebanInfinu3 from '../assets/images/EstebanInfinu/3.jpg';
import EstebanInfinu4 from '../assets/images/EstebanInfinu/4.jpg';
import EstebanInfinu5 from '../assets/images/EstebanInfinu/5.jpg';
import EstebanInfinu6 from '../assets/images/EstebanInfinu/6.jpg';
import EstebanInfinu7 from '../assets/images/EstebanInfinu/7.jpg';
import EstebanInfinu8 from '../assets/images/EstebanInfinu/8.jpg';
import EstebanInfinu9 from '../assets/images/EstebanInfinu/9.jpg';
import EstebanInfinu10 from '../assets/images/EstebanInfinu/10.jpg';

import Lagum1 from '../assets/images/Lagum/image00001.jpeg';
import Lagum2 from '../assets/images/Lagum/image00002.jpeg';
import Lagum3 from '../assets/images/Lagum/image00003.jpeg';
import Lagum4 from '../assets/images/Lagum/image00004.jpeg';
import Lagum5 from '../assets/images/Lagum/image00005.jpeg';
import Lagum6 from '../assets/images/Lagum/image00006.jpeg';
import Lagum7 from '../assets/images/Lagum/image00007.jpeg';
import Lagum8 from '../assets/images/Lagum/image00008.jpeg';
import Lagum9 from '../assets/images/Lagum/image00009.jpeg';
import Lagum10 from '../assets/images/Lagum/image00010.jpeg';
import Lagum11 from '../assets/images/Lagum/image00011.jpeg';
import Lagum12 from '../assets/images/Lagum/image00012.jpeg';
import Lagum13 from '../assets/images/Lagum/image00013.jpeg';
import Lagum14 from '../assets/images/Lagum/image00014.jpeg';
import Lagum15 from '../assets/images/Lagum/image00015.jpeg';
import Lagum16 from '../assets/images/Lagum/image00016.jpeg';
import Lagum17 from '../assets/images/Lagum/image00017.jpeg';
import Lagum18 from '../assets/images/Lagum/image00018.jpeg';

import Melin1 from '../assets/images/Melin/1.jpg';
import Melin2 from '../assets/images/Melin/2.jpg';
import Melin3 from '../assets/images/Melin/3.jpg';
import Melin4 from '../assets/images/Melin/4.jpg';
import Melin5 from '../assets/images/Melin/5.jpg';
import Melin6 from '../assets/images/Melin/6.jpg';
import Melin7 from '../assets/images/Melin/7.jpg';
import Melin8 from '../assets/images/Melin/8.jpg';
import Melin9 from '../assets/images/Melin/9.jpg';
import Melin10 from '../assets/images/Melin/10.jpg';
import Melin11 from '../assets/images/Melin/11.jpg';
import Melin12 from '../assets/images/Melin/12.jpg';

import Terno1 from '../assets/images/Terno/1.png';
import Terno2 from '../assets/images/Terno/2.png';
import Terno3 from '../assets/images/Terno/3.png';


import VitorKley1 from '../assets/images/VitorKley/image00001.jpeg';
import VitorKley2 from '../assets/images/VitorKley/image00002.jpeg';
import VitorKley3 from '../assets/images/VitorKley/image00003.jpeg';
import VitorKley4 from '../assets/images/VitorKley/image00004.jpeg';
import VitorKley5 from '../assets/images/VitorKley/image00005.jpeg';
import VitorKley6 from '../assets/images/VitorKley/image00006.jpeg';
import VitorKley7 from '../assets/images/VitorKley/image00007.jpeg';
import VitorKley8 from '../assets/images/VitorKley/image00008.jpeg';
import VitorKley9 from '../assets/images/VitorKley/image00009.jpeg';
import VitorKley10 from '../assets/images/VitorKley/image00010.jpeg';
import VitorKley11 from '../assets/images/VitorKley/image00011.jpeg';
import VitorKley12 from '../assets/images/VitorKley/image00012.jpeg';
import VitorKley13 from '../assets/images/VitorKley/image00013.jpeg';
import VitorKley14 from '../assets/images/VitorKley/image00014.jpeg';
import VitorKley15 from '../assets/images/VitorKley/image00015.jpeg';
import VitorKley16 from '../assets/images/VitorKley/image00016.jpeg';
import VitorKley17 from '../assets/images/VitorKley/image00017.jpeg';
import VitorKley18 from '../assets/images/VitorKley/image00018.jpeg';
import VitorKley19 from '../assets/images/VitorKley/image00019.jpeg';
import VitorKley20 from '../assets/images/VitorKley/image00020.jpeg';
import VitorKley21 from '../assets/images/VitorKley/image00021.jpeg';
import VitorKley22 from '../assets/images/VitorKley/image00022.jpeg';

import Ziggy1 from '../assets/images/Ziggy/image00001.jpeg';
import Ziggy2 from '../assets/images/Ziggy/image00002.jpeg';
import Ziggy3 from '../assets/images/Ziggy/image00003.jpeg';
import Ziggy4 from '../assets/images/Ziggy/image00004.jpeg';
import Ziggy5 from '../assets/images/Ziggy/image00005.jpeg';
import Ziggy6 from '../assets/images/Ziggy/image00006.jpeg';
import Ziggy7 from '../assets/images/Ziggy/image00007.jpeg';
import Ziggy8 from '../assets/images/Ziggy/image00008.jpeg';
import Ziggy9 from '../assets/images/Ziggy/image00009.jpeg';


export const artistsData = [
  {
    name: "Anavitoria",
    images: [
      { src: Anavitoria1, alt: "Anavitoria show 1" },
      { src: Anavitoria2, alt: "Anavitoria show 2" },
      { src: Anavitoria3, alt: "Anavitoria show 3" },
      { src: Anavitoria4, alt: "Anavitoria show 4" },
      { src: Anavitoria5, alt: "Anavitoria show 5" },
      { src: Anavitoria6, alt: "Anavitoria show 6" },
      { src: Anavitoria7, alt: "Anavitoria show 7" },
      { src: Anavitoria8, alt: "Anavitoria show 8" },
      { src: Anavitoria9, alt: "Anavitoria show 9" },
      { src: Anavitoria10, alt: "Anavitoria show 10" },
      { src: Anavitoria11, alt: "Anavitoria show 11" },
      { src: Anavitoria12, alt: "Anavitoria show 12" },
      { src: Anavitoria13, alt: "Anavitoria show 13" },
      { src: Anavitoria14, alt: "Anavitoria show 14" },
      { src: Anavitoria15, alt: "Anavitoria show 15" },
      { src: Anavitoria16, alt: "Anavitoria show 16" },
      { src: Anavitoria17, alt: "Anavitoria show 17" },
      { src: Anavitoria18, alt: "Anavitoria show 18" },
      { src: Anavitoria19, alt: "Anavitoria show 19" },
      { src: Anavitoria20, alt: "Anavitoria show 20" },
      { src: Anavitoria21, alt: "Anavitoria show 21" },
      { src: Anavitoria22, alt: "Anavitoria show 22" },
      { src: Anavitoria23, alt: "Anavitoria show 23" },
      { src: Anavitoria24, alt: "Anavitoria show 24" },
      { src: Anavitoria25, alt: "Anavitoria show 25" },
      { src: Anavitoria26, alt: "Anavitoria show 26" },
      { src: Anavitoria27, alt: "Anavitoria show 27" },
      { src: Anavitoria28, alt: "Anavitoria show 28" },
      { src: Anavitoria29, alt: "Anavitoria show 29" },
      { src: Anavitoria30, alt: "Anavitoria show 30" },
      { src: Anavitoria31, alt: "Anavitoria show 31" },
      { src: Anavitoria32, alt: "Anavitoria show 32" },
      { src: Anavitoria33, alt: "Anavitoria show 33" }
    ]
  },
  {
    name: "Chico Chico",
    images: [
    
      { src: ChicoChico2, alt: "Chico Chico show 2" },
       { src: ChicoChico3, alt: "Chico Chico show 2" },
      { src: ChicoChico4, alt: "Chico Chico show 2" },
      { src: ChicoChico5, alt: "Chico Chico show 2" },
      { src: ChicoChico6, alt: "Chico Chico show 2" },
      { src: ChicoChico7, alt: "Chico Chico show 2" },
      { src: ChicoChico8, alt: "Chico Chico show 2" },
      { src: ChicoChico9, alt: "Chico Chico show 2" },
      { src: ChicoChico10, alt: "Chico Chico show 2" },
      { src: ChicoChico11, alt: "Chico Chico show 2" },
      { src: ChicoChico12, alt: "Chico Chico show 2" },
      { src: ChicoChico13, alt: "Chico Chico show 2" },
      { src: ChicoChico14, alt: "Chico Chico show 2" },
      { src: ChicoChico16, alt: "Chico Chico show 2" },
      { src: ChicoChico17, alt: "Chico Chico show 2" },
      { src: ChicoChico18, alt: "Chico Chico show 2" },
   
    ]
  },
  {
    name: "Day Limns",
    images: [
         { src: DayLimns1, alt: "day limns" },
         { src: DayLimns2, alt: "day limns" },
         { src: DayLimns3, alt: "day limns" },
         { src: DayLimns4, alt: "day limns" },
         { src: DayLimns5, alt: "day limns" },
         { src: DayLimns6, alt: "day limns" },
         { src: DayLimns7, alt: "day limns" },
      
    ]
  },
  {
    name: "Esteban Infinu",
    images: [
      { src: EstebanInfinu1, alt: "esteban" },
      { src: EstebanInfinu2, alt: "esteban" },
      { src: EstebanInfinu3, alt: "esteban" },
      { src: EstebanInfinu4, alt: "esteban" },
      { src: EstebanInfinu5, alt: "esteban" },
      { src: EstebanInfinu6, alt: "esteban" },
      { src: EstebanInfinu7, alt: "esteban" },
      { src: EstebanInfinu8, alt: "esteban" },
      { src: EstebanInfinu9, alt: "esteban" },
      { src: EstebanInfinu10, alt: "esteban" },

    ]
  },
  {
    name: "Lagum",
    images: [
      { src: Lagum1, alt: "Lagum" },
      { src: Lagum2, alt: "Lagum" },
       { src: Lagum3, alt: "Lagum" },
      { src: Lagum4, alt: "Lagum" },
      { src: Lagum5, alt: "Lagum" },
      { src: Lagum6, alt: "Lagum" },
       { src: Lagum7, alt: "Lagum" },
      { src: Lagum8, alt: "Lagum" },
      { src: Lagum9, alt: "Lagum" },
       { src: Lagum10, alt: "Lagum" },
      { src: Lagum11, alt: "Lagum" },
      { src: Lagum12, alt: "Lagum" },
       { src: Lagum13, alt: "Lagum" },
      { src: Lagum14, alt: "Lagum" },
      { src: Lagum15, alt: "Lagum" },
       { src: Lagum16, alt: "Lagum" },
      { src: Lagum17, alt: "Lagum" },
      { src: Lagum18, alt: "Lagum" },
    
    ]
  },
  {
    name: "Melin",
    images: [
      { src: Melin1, alt: "Melin" },
      { src: Melin2, alt: "Melin" },
       { src: Melin3, alt: "Melin" },
      { src: Melin4, alt: "Melin" },
       { src: Melin5, alt: "Melin" },
      { src: Melin6, alt: "Melin" },
       { src: Melin7, alt: "Melin" },
       { src: Melin8, alt: "Melin" },
      { src: Melin9, alt: "Melin" },
       { src: Melin10, alt: "Melin" },
       { src: Melin11, alt: "Melin" },
      { src: Melin12, alt: "Melin" },
   
    ]
  },
  {
    name: "Terno",
    images: [
        { src: Terno1, alt: "Terno" },
        { src: Terno2, alt: "Terno" },
        { src: Terno3, alt: "Terno" },
     
    ]
  },
  {
    name: "Vitor Kley",
    images: [
        { src: VitorKley1, alt: "VictorKley" },
        { src: VitorKley2, alt: "VictorKley" },
        { src: VitorKley3, alt: "VictorKley" },
        { src: VitorKley4, alt: "VictorKley" },
        { src: VitorKley5, alt: "VictorKley" },
        { src: VitorKley6, alt: "VictorKley" },
        { src: VitorKley7, alt: "VictorKley" },
        { src: VitorKley8, alt: "VictorKley" },
        { src: VitorKley9, alt: "VictorKley" },
        { src: VitorKley10, alt: "VictorKley" },
        { src: VitorKley11, alt: "VictorKley" },
        { src: VitorKley12, alt: "VictorKley" },
        { src: VitorKley13, alt: "VictorKley" },
        { src: VitorKley14, alt: "VictorKley" },
        { src: VitorKley15, alt: "VictorKley" },
        { src: VitorKley16, alt: "VictorKley" },
        { src: VitorKley17, alt: "VictorKley" },
        { src: VitorKley18, alt: "VictorKley" },
        { src: VitorKley19, alt: "VictorKley" },
        { src: VitorKley20, alt: "VictorKley" },
        { src: VitorKley21, alt: "VictorKley" },
          { src: VitorKley22, alt: "VictorKley" },
     
     
    ]
  },
   {
    name: "Ziggy",
    images: [
        { src: Ziggy1, alt: "Ziggy" },
        { src: Ziggy2, alt: "Ziggy" },
         { src: Ziggy3, alt: "Ziggy" },
          { src: Ziggy4, alt: "Ziggy" },
           { src: Ziggy5, alt: "Ziggy" },
            { src: Ziggy6, alt: "Ziggy" },
             { src: Ziggy7, alt: "Ziggy" },
              { src: Ziggy8, alt: "Ziggy" },
               { src: Ziggy9, alt: "Ziggy" },
     
     
    ]
  }
];